class ProductBadge extends HTMLElement {
            constructor() {
                super();
                this.attachShadow({ mode: 'open' });
            }

            static get observedAttributes() {
                return ['text', 'type', 'position', 'size'];
            }

            connectedCallback() {
                // console.log('Mount product badge');
                this.render();
            }

            attributeChangedCallback() {
                this.render();
            }

            render() {
                var tags = this.tags;
                var today = new Date();
                var dateNow = today.getTime() / 1000;
                var dateCreatedAt = Date.parse(this.createdAt) / 1000;
                var timeAgo = (dateNow - dateCreatedAt) / 86400;

                // console.log('Render badges:', this.available, this.dataset.allQuantities, tags, this.createdAt, timeAgo);

  
                var productNew = false;
                if (timeAgo < 45) {
                    productNew = true;
                }

                                
                var inStore = tags.indexOf('_in_store_only') > -1 ? true : false;
                var preOrder = tags.indexOf('_preorder') > -1 ? true : false;
                var webOnly = tags.indexOf('_web_only') > -1 ? true : false;
                var tag = tags.find(function(e){return e.indexOf('_badge_') > -1});
                var customTag = (typeof tag != 'undefined') ? true : false;
                
                var qualifyingBadge = this.badgeData.find((badge) => {
                    switch(badge.type) {
                        case 'tagBadge':
                            return this.tags.includes(badge.tag)
                        case 'ageBadge':
                            return badge.rule === 'gte' ? badge.age <= timeAgo : badge.age >= timeAgo
                        case "inventoryBadge":
                            const totalInv = this.totalInv;
                            return badge.rule === 'lte' ? totalInv  <= badge.amount  : totalInv >= badge.amount;
                    }
                })
                
                var priceClass = '';
                if (inStore) {
                    priceClass += ' price--in-store-onlya ';
                } else if (this.available == false) {
                    priceClass += ' price--sold-outa ';
                } else {
                    if (this.onSale) {
                        priceClass += ' price--on-salea ';
                    }
                    if (productNew) {
                        priceClass += ' price--new-producta ';
                    }
                    if (preOrder) {
                        priceClass += ' price--pre-ordera ';
                    } else if (this.quantity <=0 && policy == 'continue') {
                        priceClass += ' price--special-ordera ';
                    }
                }

                if (this.hasSpecialOrder){
                    priceClass += ' price--special-order ';
                }

                if (customTag) {
                    priceClass += ' price--custom ';
                }

                var html = '';
                html += '<p class="boost-pfs-filter-product-item-price cstm_badge ' + priceClass + '">';
                
                if(qualifyingBadge) {
                    html += `<span class="badge price__badge-new circle-divider circle-divider--narrow">${qualifyingBadge.title}</span>`;
                }

                
                if (inStore) {
                    html += '<span class="badge price__badge-in-store-only circle-divider circle-divider--narrow">' + 'IN STORE' + '</span>';
                } else if (this.hasSpecialOrder) {
                    html += '<span class="badge price__badge-special-order circle-divider circle-divider--narrow">' + 'SPECIAL ORDER' + '</span>';
                } else if (this.available == false) {
                    html += '<span class="badge price__badge-sold-out circle-divider circle-divider--narrow">' + 'SOLD OUT' + '</span>';
                } else {
                    if (this.onSale) {
                    html += '<span class="badge price__badge-sale circle-divider circle-divider--narrow">' + 'ON SALE' + '</span>';
                    }
                    if (productNew) {
                    html += '<span class="badge price__badge-new circle-divider circle-divider--narrow">' + 'NEW' + '</span>';
                    }
                    if (preOrder) {
                    html += '<span class="badge price__badge-pre-order circle-divider circle-divider--narrow">' + 'PRE ORDER' + '</span>';
                    } else if (this.quantity <=0 && this.policy == 'continue') {
                    html += '<span class="badge price__badge-special-order circle-divider circle-divider--narrow">' + 'SPECIAL ORDER' + '</span>';
                    }
                }
                
                if (webOnly) {
                    html += '<span class="badge price__badge-web circle-divider circle-divider--narrow">' + 'WEB ONLY' + '</span>';
                }

                html += '</p>';

                // const text = this.getAttribute('text') || 'Badge';
                // const type = this.getAttribute('type') || 'primary';
                // const position = this.getAttribute('position') || 'inline';
                // const size = this.getAttribute('size') || 'medium';
                
                // console.log('BADGE HTML:', html);

                this.shadowRoot.innerHTML = `
                <style>
                    .boost-pfs-filter-product-item-price {
                        display: flex;
                        flex-wrap: wrap;
                        gap: 8px;
                    }
                    .badge {
                        color: #585d63 !important;
                        font-size: 14px !important;
                        font-weight: 600 !important;
                        padding: 5px !important;
                        border: 1px solid #585d63;
                    }

                </style>
                    ${html}
                `;
            }

            get totalInv() {
                return this.dataset.allQuantities.split(',').reduce((total, inv) => total += Number(inv), 0)
            }

            get priceMin() {
                return Number(this.dataset.price);
            }

            get compareAtPrice() {
                return Number(this.dataset.compareAtPrice);
            }

            get onSale() {
                return this.compareAtPrice > this.priceMin;
            }

            get badgeData() {
                return JSON.parse(document.querySelector('[data-product-badge-source]').innerHTML);
            }

            get createdAt() {
                return this.dataset.createdAt || null;
            }

            get tags() {
                return this.dataset.tags.split(',') || [];
            }

            get available() {
                return this.dataset.available ? this.dataset.available === 'true' : false;
            }

            get quantity() {
                return this.dataset.quantity || 0;
            }

            get policy() {
                return this.dataset.policy || 'continue';
            }

            get hasSpecialOrder() {
                return this.hasAttribute('data-special-order');
            }
        }

        // Register the custom element
        customElements.define('product-badge', ProductBadge);